import { Progress, radiusCva, Text, useProvider } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { toastCva } from "./cva"

interface ProgressIndicatorToastProps {
	progress: number
	description?: string
}

export const ProgressIndicatorToast = memo<ProgressIndicatorToastProps>((props) => {
	const { progress, description } = props
	const { radius } = useProvider()

	return (
		<div className={cx(radiusCva({ radius, maxLarge: true }), toastCva(), "flex flex-col gap-2 p-4")}>
			<Text size="sm" accentColor="base">
				{description}
			</Text>
			<Progress value={progress} />
		</div>
	)
})
ProgressIndicatorToast.displayName = "ProgressIndicatorToast"
